var map = {
	"./en.js": "80fd",
	"./pt-br.js": "ffb4",
	"./pt-br/actions.js": "5067",
	"./pt-br/drawer.js": "bf14",
	"./pt-br/filters.js": "5659",
	"./pt-br/forms.js": "98bb",
	"./pt-br/httpErrors.js": "1f44",
	"./pt-br/permissions.js": "cb7f",
	"./pt-br/reports.js": "75b1",
	"./pt-br/resources.js": "4f1d",
	"./pt-br/routes.js": "0028"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b4e";